<template>
  <div class="item">
    <div class="content">
      <div class="content-body">
        <div class="body-detail">
          <div
            class="
              detail-address
            ">
            <b>
              {{ item.addressNo || 'N/A' }}
            </b>
          </div>
          <!-- <p
            class="
              detail-address
            "
            :class="{
              unknown: !item.addressNo
            }">
          </p> -->
          
          <div
            class="
              detail-user
            ">
            <b>
              {{ item.roleName || 'N/A' }}
            </b>
            <p class="subtitle">
              {{ item.name || 'N/A' }}
            </p>
          </div>
        </div>
        <hr
          divider="content"
        />
        <div class="body-contact">
          <p class="contact-empty">
            &nbsp;
          </p>
          <p
            :class="{
              unknown: !item.mobileNo
            }">
            {{ item.mobileNo || 'N/A' }}
          </p>
          <p
            v-if="
              item.email
            ">
            {{ item.email || 'N/A' }}
          </p>
        </div>
      </div>
    </div>
    <hr
      divider="action"
    />
    <div class="action">
      <el-button
        v-if="allow"
        plain
        circle
        readonly>
        <i 
          class="el-icon-circle-check valid"
        />
      </el-button>
      <el-button v-else
        plain
        circle
        readonly
        @click="
          () => alert = true
        ">
        <i 
          class="el-icon-warning invalid"
        />
      </el-button>
      <el-button
        circle
        plain
        readonly
        @click="
          () => $emit('copy')
        ">
        <i 
          class="el-icon-copy-document"
        />
      </el-button>
      <el-button
        circle
        type="sc-asset"
        @click="
          () => $emit('update')
        ">
        <i 
          class="el-icon-edit"
        />
      </el-button>
    </div>
    <NonScAlert
      class="alert-error"
      :open="alert"
      type="error"
      @closed="
        () => alert = false
      ">
      <template #body>
        <div class="error-message">
          <p v-for="(message, i) in error" :key="i">
            {{ message }}
          </p>
        </div>
      </template>
    </NonScAlert>
  </div>
</template>

<script lang="js">

// Components
import NonScAlert from '../../components/NonScAlert.vue'

// Common
import {
  NonScImportCommon as ImportCommon
} from '../../common/nonsc-home-import.common'

export default {
  components: {
    NonScAlert
  },
  props: {
    item: {
      type: Object,
      default: () => ImportCommon.item
    }
  },
  data() {

    // Init Input
    const input = ImportCommon.item

    return {
      alert: false, input
    }
  },
  watch: {
    item: {
      handler() {
        this.setter()
      },
      deep: true
    }
  },
  mounted() {
    this.setter()
  },
  computed: {
    allow() {

      // Item Props
      const { valid } = this.item

      // Validate Props
      if (!valid) return null

      // Validator State
      const { all } = valid
      
      // Validate State
      if (typeof all == 'boolean') return all
    },
    error() {

      // Valid State
      const { valid } = this.input

      // Validate State
      if (!valid) return []

      // Required State
      const required = Object
        .entries(valid)
        .filter(
          ([key]) => (
            key != 'all' && key != 'id'
          )
        )

      // Error Message
      const message = ImportCommon.error

      return required
        .filter(
          ([_, value]) => value == false
        )
        .map(
          ([key]) => message[key]
        )
    }
  },
  methods: {
    setter() {
      this.input = (
        Object.assign({}, this.item)
      )
    }
  }
}
</script>

<style lang="css" scoped>

.item,
.item .content,
.item .action {
  display     : flex;
  align-items : center;
  gap         : var(--size-xs);
}
.item {
  padding     : var(--size-sm);
  align-items : unset;
}
.item .content {
  flex: 1;
}
.item .action {
  flex        : none;
  display     : flex;
  align-items : center;
}

.content-body {
  display : flex;
  width   : 100%;
  gap     : var(--size-xs);
}
.content-body .body-detail {
  flex: 3;
}
.content-body .body-contact {
  flex: 2;
}

.body-detail,
.body-contact {
  display: flex;
}

.body-detail {
  gap: var(--size-xs);
}
.detail-address {
  flex: 1;
}
.detail-user {
  flex: 3;
}

.body-contact {
  flex-direction  : column;
  align-items     : center;
  justify-content : center;
}
.contact-empty {
  display: none;
}

hr[divider=content],
hr[divider=action] {
  display: none;
}

.address-no {
  font-size: 1.125rem;
}

.action i {
  font-size: 1rem;
}

.error-message {
  width: 100%;
}
.error-message p {
  padding       : .25rem 0;
  border-bottom : var(--border);
}
.error-message p:last-child {
  border-bottom: unset;
}

@media screen and (max-width: 1280px) {

  .item {
    flex-direction  : column;
    padding         : var(--size-md);
  }

  .item .action {
    justify-content: flex-end;
  }

  hr[divider=action] {
    display: block;
  }

  .content-body {
    align-items     : flex-start;
    justify-content : flex-end;
  }

  .body-detail {
    gap             : 0;
    flex-direction  : column;
  }
  
  .body-contact {
    align-items: flex-end;
  }
  .contact-empty {
    display: block;
  }
}

@media screen and (max-width: 480px) {
  
  .item,
  .item .content {
    gap: 0;
    flex-direction: column;
  }

  .item,
  .item .action {
    gap: var(--size-sm);
  }

  hr[divider=content] {
    display: block;
  }

  .content-body {
    gap             : var(--size-sm);
    flex-direction  : column;
  }

  .body-contact {
    justify-content : flex-start;
    align-items     : flex-start;
  }
  .contact-empty {
    display: none;
  }
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/project-import/NonScImportItem.vue